(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["ot-notifications"] = {}));
})(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var NotificationHandle = /** @class */ (function () {
        function NotificationHandle(container, message, className, infoIcon) {
            this._disposed = false;
            this._element = document.createElement("div");
            this._element.className = "ot-notification ".concat(className);
            this._content = document.createElement("div");
            this._content.className = "ot-notification-content";
            if (infoIcon) {
                var iconContainer = document.createElement("div");
                iconContainer.className = "ot-notification-content__info-icon";
                iconContainer.innerHTML = '<svg width="22px" height="18px" viewBox="0 0 22 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill-rule="evenodd"><path d="M11,2 C5.80967,2 2,5.33071 2,9 C2,12.6693 5.80967,16 11,16 C16.1903,16 20,12.6693 20,9 C20,5.33071 16.1903,2 11,2 Z M0,9 C0,3.83274 5.14463,0 11,0 C16.8554,0 22,3.83274 22,9 C22,14.1673 16.8554,18 11,18 C5.14463,18 0,14.1673 0,9 Z M10,10 L10,4 L12,4 L12,10 L10,10 Z M10,14 L10,12 L12,12 L12,14 L10,14 Z"></path></g></svg>';
                this._content.appendChild(iconContainer);
            }
            var textContainer = document.createElement("div");
            textContainer.className = "ot-notification-content__text-container";
            this._text = document.createElement("p");
            this._text.className = "ot-notification-content__text";
            this._text.innerHTML = typeof message === 'string' ? message : message.text;
            textContainer.appendChild(this._text);
            if (typeof message !== 'string') {
                this._subText = document.createElement("p");
                this._subText.className = "ot-notification-content__sub-text";
                this._subText.innerHTML = message.subText;
                textContainer.appendChild(this._subText);
            }
            this._content.appendChild(textContainer);
            this._element.appendChild(this._content);
            container.appendChild(this._element);
        }
        Object.defineProperty(NotificationHandle.prototype, "disposed", {
            get: function () {
                return this._disposed;
            },
            enumerable: false,
            configurable: true
        });
        NotificationHandle.prototype.updateText = function (text) {
            this._text.innerHTML = text;
        };
        NotificationHandle.prototype.updateSubText = function (text) {
            this._subText.innerHTML = text;
        };
        NotificationHandle.prototype.addContent = function (htmlElement) {
            this._content.appendChild(htmlElement);
        };
        NotificationHandle.prototype.show = function () {
            this._element.classList.add("ot-notification--show");
        };
        NotificationHandle.prototype.hide = function () {
            // A hide animation can be added here if needed
            this.destroy();
        };
        NotificationHandle.prototype.destroy = function () {
            if (!this._element.parentElement) {
                this._disposed = true;
                return;
            }
            this._element.parentElement.removeChild(this._element);
            this._disposed = true;
        };
        return NotificationHandle;
    }());

    var defaults = {
        type: "is-info",
        position: "topCenter",
        infoIcon: true,
        duration: 5000,
        closeable: true,
        singleNotification: false
    };
    var NotificationController = /** @class */ (function () {
        function NotificationController(config) {
            this._containers = {
                topLeft: null,
                topCenter: null,
                topRight: null,
                bottomRight: null,
                bottomCenter: null,
                bottomLeft: null
            };
            var _config = Object.assign({}, defaults);
            this._config = Object.assign(_config, config || {});
        }
        NotificationController.prototype.info = function (config) {
            return this._show(config, "is-info");
        };
        NotificationController.prototype.success = function (config) {
            return this._show(config, "is-success");
        };
        NotificationController.prototype.warning = function (config) {
            return this._show(config, "is-warning");
        };
        NotificationController.prototype.danger = function (config) {
            return this._show(config, "is-danger");
        };
        NotificationController.prototype.show = function (config) {
            return this._show(config);
        };
        NotificationController.prototype._show = function (config, type) {
            if (typeof config === "string") {
                config = { message: config };
            }
            if (!config.message) {
                throw Error('No message provided');
            }
            var fullConfig = __assign(__assign({}, this._config), config);
            if (type) {
                fullConfig.type = type;
            }
            var container = this._createOrGetContainer(fullConfig.position);
            if (this._config.singleNotification) {
                container.innerHTML = "";
            }
            var notification = new NotificationHandle(container, fullConfig.message, fullConfig.type, fullConfig.infoIcon);
            var currentTimeout;
            if (fullConfig.closeable) {
                var button = this._createCloseButton(function () {
                    if (currentTimeout) {
                        currentTimeout = window.clearTimeout(currentTimeout);
                    }
                    notification.hide();
                });
                notification.addContent(button);
            }
            notification.show();
            if (fullConfig.duration) {
                currentTimeout = window.setTimeout(function () {
                    notification.hide();
                }, fullConfig.duration);
            }
            return notification;
        };
        NotificationController.prototype._createCloseButton = function (action) {
            var closeIcon = '<svg width="12px" height="10px" viewBox="0 0 12 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill-rule="evenodd"><g><polygon points="6.00021 6.2337 1.65152 9.41899 0.469696 7.80552 4.30791 4.99414 0.508434 2.21113 1.69026 0.597656 6.00021 3.75457 10.3102 0.597656 11.492 2.21113 7.69251 4.99414 11.5307 7.80552 10.3489 9.41899"></polygon></g></g></svg>';
            var button = this._createButton('Close', action, closeIcon);
            button.className = button.className + " ot-notifcation-close";
            return button;
        };
        NotificationController.prototype._createButton = function (label, action, icon) {
            var button = document.createElement("button");
            button.className = 'ot-notification-content__btn';
            var labelEl = document.createElement("div");
            labelEl.className = "ot-notification-content__btn-label";
            labelEl.innerHTML = label;
            button.appendChild(labelEl);
            if (icon) {
                var iconEl = document.createElement("div");
                iconEl.className = "ot-notification-content__btn-icon";
                iconEl.innerHTML = icon;
                button.appendChild(iconEl);
            }
            button.addEventListener("click", action);
            return button;
        };
        NotificationController.prototype._createOrGetContainer = function (position) {
            if (position === void 0) { position = "bottomCenter"; }
            if (!this._containers[position]) {
                var container = this._containers[position] = document.createElement("div");
                var positionDetails = position.split(/(?=[A-Z])/).map(function (p) { return p.toLowerCase(); });
                var positionY = positionDetails[0];
                var positionX = positionDetails[1];
                container.className = "ot-notification-container is-".concat(positionY, " is-").concat(positionY, "--").concat(positionX);
                document.body.appendChild(container);
            }
            return this._containers[position];
        };
        return NotificationController;
    }());

    var VueNotifications = /** @class */ (function (_super) {
        __extends(VueNotifications, _super);
        function VueNotifications() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        VueNotifications.install = function (Vue, options) {
            if (!Vue.prototype.$notifications) {
                Vue.prototype.$notifications = new NotificationController(options);
            }
            else {
                throw Error('@/vue-notifications already registered');
            }
        };
        return VueNotifications;
    }(NotificationController));

    exports.NotificationController = NotificationController;
    exports.NotificationHandle = NotificationHandle;
    exports["default"] = VueNotifications;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
